export type PhoneCountry = {
  /** ISO 3166-1 alpha-2 (e.g. "QA"). Used to render the flag emoji. */
  iso2: string;
  /** Human-readable country name. */
  name: string;
  /** E.164 dial code prefix including the leading "+". */
  dialCode: string;
};

export const DEFAULT_PHONE_COUNTRIES: readonly PhoneCountry[] = [
  { iso2: "QA", name: "Qatar", dialCode: "+974" },
  { iso2: "AE", name: "United Arab Emirates", dialCode: "+971" },
  { iso2: "SA", name: "Saudi Arabia", dialCode: "+966" },
  { iso2: "BH", name: "Bahrain", dialCode: "+973" },
  { iso2: "KW", name: "Kuwait", dialCode: "+965" },
  { iso2: "OM", name: "Oman", dialCode: "+968" },
  { iso2: "EG", name: "Egypt", dialCode: "+20" },
  { iso2: "JO", name: "Jordan", dialCode: "+962" },
  { iso2: "LB", name: "Lebanon", dialCode: "+961" },
  { iso2: "TR", name: "Turkey", dialCode: "+90" },
  { iso2: "GB", name: "United Kingdom", dialCode: "+44" },
  { iso2: "US", name: "United States", dialCode: "+1" },
  { iso2: "DE", name: "Germany", dialCode: "+49" },
  { iso2: "FR", name: "France", dialCode: "+33" },
  { iso2: "ES", name: "Spain", dialCode: "+34" },
  { iso2: "IT", name: "Italy", dialCode: "+39" },
  { iso2: "IN", name: "India", dialCode: "+91" },
  { iso2: "PK", name: "Pakistan", dialCode: "+92" },
];
